// Models
import { RuleGroupType } from 'react-querybuilder';

import { FormulaType } from '../constants/formulaType';

import {
    AUDIENCE_FILTER_TYPE,
    AttributeOperatorModel,
    ContactAttributeModel,
    CreateFilterAttributeModel,
} from './contact_attributes.model';
import { FormulaSequenceCatalogModel } from './formula-sequence.model';
import { FormulaState } from './formula.model';

export const AUDIENCE_FILTER_MAIN_CONTAINER = 'audience_filter_main_container';

export interface AudienceCreateModel {
    attribute_id: number;
    operator_id: number;
    value: string;
}

export interface AudienceMainBaseModel {
    name: string;
    description?: string;
}

export interface AudienceUpdateFilterModel extends AudienceMainBaseModel {
    filters: AudienceCreateModel[];
}

export interface AudienceCategoryModel {
    value: number;
    category: AudienceCategory;
    order: number;
    description: string;
}
export enum AudienceCategory {
    Active = 'Active',
    Inactive = 'Inactive',
    Lurking = 'Lurking',
    New = 'New',
    Recent = 'Recent',
    All = 'All',
}

export interface AudienceEstimatorModel {
    total_audience: number;
    total_filtered_audience: number;
    category: AudienceCategoryModel[];
}

export interface FormulaAudienceModel {
    id: number;
    name: string;
    active_state: FormulaState;
    message_type: FormulaType;
    message_count: number;
}
export interface AudienceFiltersFormValues {
    filter_attributes: CreateFilterAttributeModel[][];
    filter_type: AUDIENCE_FILTER_TYPE;
}
export interface AudienceFilterModel {
    id: string;
    value: string;
    attribute: ContactAttributeModel;
    operator: AttributeOperatorModel;
}

export interface AudienceBaseModel {
    id: string;
    name: string;
    description?: string;
    created_at: string;
}

export enum AudienceStatus {
    Active = 'Active',
    Available = 'Available',
    Archived = 'Archived',
    Inactive = 'Inactive',
}

export interface AudienceModel extends AudienceBaseModel {
    formula_count: number;
    sequence_count: number;
    status?: AudienceStatus;
}

export interface AudienceDetailModel extends AudienceBaseModel {
    filters: AudienceFilterModel[];
    filters_json: RuleGroupType;
}

export interface AudienceMainModel extends AudienceBaseModel {
    filters: AudienceFilterModel[];
    formulas?: FormulaAudienceModel[];
    formula_sequences?: FormulaSequenceCatalogModel[];
    formula_count?: Number;
    created_at: string;
}

export enum AudienceActionState {
    Save = 'Save',
    Create = 'Create',
    CreateMessage = 'Create message',
    CreateAudienceAndOpenMessage = 'Save & create message',
}
export interface AudienceFiltersFormModel {
    audience_name: string;
    audience_description?: string;
    filter_attributes: CreateFilterAttributeModel[][];
    filter_type: AUDIENCE_FILTER_TYPE;
    action?: AudienceActionState;
}

export const ALL_USERS_AUDIENCE_ID = 'all_users';

export const AllUsers: AudienceMainModel = {
    id: ALL_USERS_AUDIENCE_ID,
    name: 'All Users',
    description: 'This audience shows metrics of all the users',
    created_at: '',
    filters: [],
};
export interface AudienceCloneModel {
    name: string;
    description?: string;
}
